import { useMemo, useState } from 'react'
import { CuiButton } from 'front-lib'
import { BoxSize } from '../BoxOrderPlanModal'
import classNames from 'classnames'

interface Props {
  userPlanMatchBoxId?: BoxSize['id']
  mostPopularBoxId?: BoxSize['id']
  boxes: BoxSize[]
  onConfirm: (planBoxId: BoxSize['id']) => void
  onBack: () => void
}

export const BoxSelectionStep = ({
  boxes,
  userPlanMatchBoxId,
  onConfirm,
  onBack,
  mostPopularBoxId
}: Props) => {
  const matchBox = useMemo(
    () => boxes?.find(box => box.id === userPlanMatchBoxId),
    [boxes, userPlanMatchBoxId]
  )
  const [selectedBox, setSelectedBox] = useState<BoxSize | undefined>(matchBox)

  return (
    <div className="modal__content">
      <div className="modal__title center small">
        {matchBox
          ? `The ${matchBox?.title} box matches your current plan`
          : 'Select your box size'}
      </div>
      <div className="modal__text">
        Remember, you can always change your default box size right in your cart
        or in your Account settings.
        <br />
        <strong>The bigger the box, the more you save! </strong>
      </div>

      <div className="box-sizes">
        <h2 className="box-sizes__title">Available box sizes:</h2>
        <ol className="box-sizes__list">
          {boxes.map(boxSize => (
            <li key={boxSize.id}>
              <BoxSizeOption
                mostPopular={boxSize.id === mostPopularBoxId}
                boxSize={boxSize}
                isSelected={boxSize.id === selectedBox?.id}
                onSelect={() => setSelectedBox(boxSize)}
              />
            </li>
          ))}
        </ol>
      </div>

      <div className="modal__buttons column">
        <CuiButton
          className="full"
          onClick={() => onConfirm(selectedBox?.id!)}
          disabled={!selectedBox}>
          Select box
        </CuiButton>
        <button className="back-button" onClick={onBack}>
          Go back
        </button>
      </div>
    </div>
  )
}

const BoxSizeOption = ({
  boxSize,
  isSelected,
  onSelect,
  mostPopular = false
}: {
  boxSize: BoxSize
  isSelected: boolean
  onSelect: () => void
  mostPopular?: boolean
}) => {
  return (
    <div>
      <button
        className={classNames(`box-sizes__item`, { selected: isSelected })}
        onClick={onSelect}
        aria-label={`${boxSize.title} box with ${
          boxSize.mealsPerBox
        } items starting at $${boxSize.minPrice}${
          boxSize.discount ? `, ${boxSize.discount * 100}% discount` : ''
        }${mostPopular ? ', most popular option' : ''}`}
        aria-pressed={isSelected}>
        <h3>{boxSize.title}</h3>
        <p>{boxSize.mealsPerBox} Items</p>
        <p>
          <strong>Starting at ${boxSize.minPrice}</strong>
        </p>
        <p className="discount">
          {boxSize.discount ? `${boxSize.discount * 100}% OFF` : ''}
        </p>
        {mostPopular && (
          <div className="most-popular">
            <p>MOST POPULAR</p>
          </div>
        )}
      </button>
    </div>
  )
}
